import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { OnLeave } from 'src/app/interfaces/shared/guard';

@Injectable({ providedIn: 'root' })
export class LeaveGuard implements CanDeactivate<unknown> {

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

    if (this.hasOnLeave(component)) {
      return component.onLeave();
    }

    return true;
  }

  private hasOnLeave(component: any): component is OnLeave {
    return component && typeof component.onLeave === 'function';
  }
}
